import Button from '../Button';
import Global from '../Global';
import { Modal, ModalPart, ModalName } from '../Modal';

const Error = () => (
  <>
    <Global />
    <Modal>
      <ModalName>Error</ModalName>
      <ModalPart>
        Something went wrong. Don't worry, we tracked the error.
      </ModalPart>
      <ModalPart>
        <Button onClick={() => location.reload()} isPrimary isExtended>
          Reload
        </Button>
      </ModalPart>
    </Modal>
  </>
);

export default Error;
